import { ApiResponse } from "../schemas/apiResponseSchema";
import apiClient from "../clients/apiClient";
import { ItReportTemplateResponse } from "./reportService";

export async function fetchReportMenus(): Promise<ItReportTemplateResponse[]> {
    try {
        const response: ApiResponse<ItReportTemplateResponse[]> = (await apiClient.get('/report/list_reports')).data
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Fetching report menus failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function fetchUserEnabledReports(userId: number): Promise<ItReportTemplateResponse[]> {
    try {
        // Fetch all report templates
        const allReportsResponse: ApiResponse<ItReportTemplateResponse[]> = (await apiClient.get('/report/list_reports')).data;
        const allReports = allReportsResponse.data;

        // Fetch user's enabled report IDs
        const userReportsResponse: ApiResponse<number[]> = (await apiClient.get(`/users/${userId}/reports`)).data;
        const enabledReportIds = new Set(userReportsResponse.data);

        // Filter to only enabled reports
        return allReports.filter(report => enabledReportIds.has(report.id || 0));
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Fetching user enabled reports failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function updateUserFavouriteMenu(menuId: number, favourite: boolean): Promise<void> {
    try {
        await apiClient.post(`/users/upldate_favourite_menu`, {
            menu_id: menuId,
            favourite: favourite
        });
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Updating favourite menu failed');
        }
        throw new Error('network error, please contact support team');
    }
}